<template>
    <div>
        <confirm ref="confirm"></confirm>
        <list :label="$t('advertising')" v-bind:refresh="this.refresh" table='advertising' v-on:childMessage="onMessageFromListReceived" initialSortBy="img_url" :initialSortDesc="false"></list>
        <v-dialog @click:outside="showImage = false" @keydown.esc="showImage = false" v-bind:value="showImage" max-width="800">
            <v-card>
                <v-img v-bind:src=url></v-img>
                <v-btn class="white--text" color="#49a5ac" fab center dark @click="showImage = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card>
        </v-dialog>
        <v-dialog v-bind:value="showFileDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    {{$t("upload file")}}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon dense right color="primary" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>{{$t('import advertising')}}</span>
                    </v-tooltip>
                </v-card-title>
                <v-card-text>
                    <v-file-input show-size v-model=file :label="$t('select file')"/>
                    <v-select v-model="folder" :label="$t('type')" :items=getFolders()></v-select>
                    <v-checkbox v-model="overwrite" :label="$t('overwrite file')"></v-checkbox>
                    <v-select v-if="isAdmin()" v-model="customerId" label="Kunde" :items=getCustomers() item-text="customername" item-value="id"></v-select>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=submitFile><v-icon dense left>mdi-cloud-upload-outline</v-icon>{{$t("upload")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t("cancel")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-bind:value="showDialog" v-bind:persistent="true" max-width="600">
            <v-hover>
                <template v-slot:default="{ hover }">
                    <v-card>
                        <img height=200 v-bind:src="generateDownloadUrl(fields)" @click="downloadImage">
                        <v-fade-transition>
                            <v-overlay v-if="hover" absolute>
                                <v-btn class="white--text" color="#49a5ac" fab @click="showImage = true"><v-icon>mdi-magnify-plus</v-icon></v-btn>
                            </v-overlay>
                        </v-fade-transition>
                    </v-card>
                </template>
            </v-hover>
            <v-card>
                <v-card-title>
                    {{title}}
                </v-card-title>
                <v-card-text>
                    <div v-for="field in fields" v-bind:key="field.value">
                        <div v-if="field.value !== 'id' && field.value !== 'actions'">
                            <v-switch v-if="field.value == 'slide' || field.value == 'processed' || field.value == 'relevant'" dense v-model="field.model" v-bind:label="field.text"></v-switch>
                            <v-text-field v-else-if="field.value == 'startdate' || field.value == 'enddate'" type="date" dense v-model="field.model" v-bind:label="field.text"></v-text-field>
                            <v-select v-else-if="field.value == 'name'" v-model="field.model" v-bind:label="field.text" :items=getPharmacies() item-text="name" item-value="id"></v-select>
                            <v-text-field v-else v-model="field.model" v-bind:label="field.text"/>
                        </div>
                    </div>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=save()><v-icon dense left>mdi-content-save-outline</v-icon>{{$t("save")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t("cancel")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=uploadFile()><v-icon dense left>mdi-file-upload-outline</v-icon>{{$t("upload file")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api"
import { Utils } from "@/Utils"
import Confirm from "@/components/Confirm";

export default {
    components:
    {
        List, Confirm
    },

    data()
    {
        return {
            customerId: "",
            hover: false,
            url: "",
            showDialog: "",
            showFileDialog: "",
            file: null,
            folder: "Allgemein",
            overwrite: false,
            showImage: false,
            fields: [],
            refresh: 0,
            title: "",
            text: ""
        };
    },

    mixins: [Utils],

    methods:
    {
        downloadImage: function()
        {
            if (this.url)
                window.open(this.url)
        },
        submitFile()
        {
            if (!this.file)
            {
                this.text = this.$t("select file");
                return;
            }
            const self = this;
            this.text = "";
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('type', "ADVERTISING");
            formData.append('folder', this.folder);
            formData.append('overwrite', this.overwrite);
            if (this.isAdmin())
                formData.append('customerId', this.customerId)

            Api.uploadFile(formData)
            .then(function(e)
            {
                if (e.data.result == "processed")
                {
                    self.$refs.confirm.open(self.$t("file processed"), {confirm:false}).then((confirm) =>
                    {
                        self.cancel();
                    });
                }
                else if (e.data.result == "error")
                {
                    self.text = self.$t("processing not possible");
                    if (e.data.details)
                        self.text += " " + e.data.details;
                }
                else
                    self.cancel();

                self.refresh++;
            })
            .catch(function(e)
            {
                if (e.response.status === 409)
                    self.text = self.$t("already exists")
                else
                    self.text = self.$t("action not possible")
            });
        },
        uploadFile ()
        {
            this.cancel();
            this.showFileDialog = true;
        },
        generateDownloadUrl: function(fields)
        {
            let source = null;
            let pharmacy = null;
            for (let field of fields)
            {
                if (field.value == "img_url")
                    source = field.model;
                else if (field.value == "name")
                    pharmacy = this.getPharmacyName(field.model);

                if (source && pharmacy)
                    break;
            }
            if (source)
            {
                this.url = source;
                return this.url;
            }
            return "";
        },
        onMessageFromListReceived (message)
        {
            this.text = "";
            if (message.cmd === "newRecord")
            {
                this.title = this.$t("new advertising")
                this.fields = JSON.parse(JSON.stringify(message.header));
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {
                    field.model = "";
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("update advertising");
                this.fields = JSON.parse(JSON.stringify(message.header));

                for (let field of this.fields)
                {
                    if (field.value == "startdate" || field.value == "enddate")
                    {
                        if (message.item[field.value])
                        {
                            const d = new Date(message.item[field.value]);
                            let month = d.getMonth()+1;
                            if (month < 10)
                                month = "0"+month;

                            let day = d.getDate();
                            if (day < 10)
                                day = "0"+day;

                            field.model = d.getFullYear()+"-"+month+"-"+day
                        }
                        else
                            field.model = message.item[field.value]
                    }
                    else if (field.value === "name")
                    {
                        const pharmacyId = this.getPharmacyId(message.item[field.value]);
                        if (pharmacyId > 0)
                            field.model = pharmacyId;
                        else
                            field.model = ""
                    }
                    else
                        field.model = message.item[field.value]
                }
                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord("advertising", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refresh += 1;
                    }
                    else
                        alert (self.$t("action not possible"));

                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        },
        cancel ()
        {
            this.customerId = "";
            this.showDialog = "";
            this.showFileDialog = "";
            this.fields = [];
            this.text = "";
            this.file = null;
        },
        save ()
        {
            const self = this;
            this.text = "";

            Api.saveRecord("advertising", this.fields).then(function(result)
            {
                if (result.status === 200)
                {
                    self.showDialog = "";
                    self.refresh += 1;
                }
                else
                    self.text = self.$t("action not possible");

            })
            .catch((e) =>
            {
                self.text = self.$t("action not possible");
            });
        }
    }
};
</script>
